export default __webpack_public_path__ + "static/media/colores-senda.ae85455b.png";